module.exports = __webpack_public_path__ + "img/medical-rays-x.b7dd85d1.svg";